<template>
  <div class="w-full">
    <ItemView ref="itemView" />
    <ProposeTagsModal ref="proposeTagsModal" />
  </div>
</template>

<script setup>
import { ref, provide, onMounted } from 'vue';
import ItemView from '../../../components/ItemView/ItemView.vue';
import ProposeTagsModal from './ProposeTagsModal.vue';

const itemView = ref(null);
const proposeTagsModal = ref(null);

provide('proposeTagsModal', proposeTagsModal);
</script>
